import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React, { Fragment, useState } from "react"
import ReactPlayer from "react-player"
import BackgroundTheme from "./common/background-theme"
import clsx from "clsx"
import { Dialog, Transition } from "@headlessui/react"
import IconSpinner from "./common/IconSpinner"

export default function Hero({
  data,
  startTrading,
  viewVideo,
  backgroundVideoUrl,
}) {
  const [isVideoOpen, setIsVideoOpen] = useState(false)

  return (
    <>
      <section>
        <div className="relative h-[calc(100vh-60px)] max-h-[600px] md:max-h-[750px] lg:max-h-[850px] flex items-center section-fadein-up overflow-hidden">
          <div className="absolute z-0 flex items-center justify-center w-full h-full">
            {backgroundVideoUrl ? (
              <>
                <div className="absolute top-0 left-0 z-20 w-full h-full pointer-events-none bg-black/40" />
                <div className="absolute top-0 left-0 z-0 w-full h-full bg-black pointer-events-none"></div>
                <ReactPlayer
                  url={backgroundVideoUrl}
                  className="absolute z-10 react-player-bg"
                  width="100%"
                  height="100%"
                  muted={true}
                  playsinline={true}
                  loop={true}
                  playing={true}
                />
              </>
            ) : (
              <>
                {data.featuredImage.node.gatsbyImageData && (
                  <GatsbyImage
                    alt="image"
                    image={getImage(data.featuredImage.node.gatsbyImageData)}
                    className="object-cover w-full h-full"
                  />
                )}
              </>
            )}
          </div>

          <div
            className={clsx(
              "container relative mx-auto fadein-up invisible",
              backgroundVideoUrl ? "text-white" : "text-secondary"
            )}
          >
            <div className="max-w-[465pt]">
              <h1
                className={clsx(
                  "heading hero-h",
                  backgroundVideoUrl ? "!text-white" : ""
                )}
              >
                {data.pageHeader.heading}
              </h1>
              <div
                className="mt-3 article-style excerpt"
                dangerouslySetInnerHTML={{
                  __html: data.pageHeader.description,
                }}
              ></div>
              <div className="mt-10 space-x-6">
                {startTrading && (
                  <a
                    href={startTrading.url ?? "#"}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="rounded-full py-2.5 font-bold text-sm capitalize inline-flex justify-center border border-transparent items-center leading-none space-x-2 bg-transparent transition-all duration-300 bg-white text-dark px-5 hover:bg-primary hover:text-dark focus:ring-1 focus:ring-white outline-0 ring-offset-2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 5.92 10.02"
                      width="6"
                    >
                      <polygon
                        fill="currentColor"
                        points=".67 10.02 0 9.29 4.5 5.18 .39 .67 1.13 0 5.92 5.24 .67 10.02"
                      />
                    </svg>
                    <span>{startTrading.title ?? "Start Trading"}</span>
                  </a>
                )}
                {viewVideo && (
                  <button
                    // href={viewVideo.url ?? "#"}
                    type="button"
                    onClick={() => setIsVideoOpen(true)}
                    className="rounded-full py-2.5 font-bold text-sm capitalize inline-flex justify-center border border-transparent items-center leading-none space-x-2 bg-transparent transition-all duration-300 text-white hover:text-primary focus:text-primary focus:ring-1 focus:ring-primary px-2"
                  >
                    <span>{viewVideo.title}</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <BackgroundTheme data={data.pageHeader} />
      </section>

      {viewVideo?.url && (
        <Transition appear show={isVideoOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            onClose={() => setIsVideoOpen(false)}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-50" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex items-center justify-center min-h-full p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="relative w-full max-w-5xl overflow-hidden text-left align-middle transition-all transform rounded-md shadow-xl bg-black/90 aspect-video">
                    <button type="button" className="absolute z-20 text-white top-1 right-1 hover:text-primary" onClick={() => setIsVideoOpen(false)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-12 h-12"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                      <span className="sr-only">Close</span>
                    </button>
                    <div className="relative z-10 flex items-center justify-center w-full h-full">
                      <IconSpinner className="absolute z-0 w-16 h-16 animate-spin text-primary" />
                      <ReactPlayer
                        url={viewVideo.url}
                        controls={true}
                        playing={true}
                        loop={true}
                        width="100%"
                        height="100%"
                        className="absolute top-0 left-0 z-10 rounded-md"
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      )}
    </>
  )
}
